"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DoorEffect = /** @class */ (function (_super) {
    __extends(DoorEffect, _super);
    function DoorEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doorRef = react_1.default.createRef();
        return _this;
    }
    DoorEffect.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, className = _a.className, duration = _a.duration, open = _a.open;
        var door = this.doorRef.current;
        if (door && open !== prevProps.open) {
            if (open) {
                window.requestAnimationFrame(function () { return door.classList.add(className + "-open"); });
            }
            else {
                door.classList.remove(className + "-open");
                window.requestAnimationFrame(function () { return door.classList.add(className + "-closed"); });
                window.setTimeout(function () { return door.classList.remove(className + "-closed"); }, duration);
            }
        }
    };
    DoorEffect.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (react_1.default.createElement("div", { ref: this.doorRef, className: className }, children));
    };
    DoorEffect.defaultProps = {
        duration: 150
    };
    return DoorEffect;
}(react_1.default.PureComponent));
exports.default = DoorEffect;
